var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureDare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_4389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.716797 15.0625H7.2793V16H13.8418V9.375H11.0293V7.61375L15.2834 3.35963L13.2947 1.37088L11.0293 3.63625V0.9375H8.13617C7.94267 0.391937 7.42164 0 6.81055 0H4.93555C4.32445 0 3.80342 0.391937 3.60992 0.9375H0.716797V15.0625ZM12.9043 15.0625H8.2168V10.3125H9.1543V12.1875H11.9668V10.3125H12.9043V15.0625ZM10.0918 10.3125H11.0293V11.25H10.0918V10.3125ZM9.8172 7.5H9.1543V6.83709L11.9689 4.02253L12.6318 4.68544L9.8172 7.5ZM13.9576 3.35963L13.2947 4.02253L12.6318 3.35963L13.2947 2.69672L13.9576 3.35963ZM4.4668 1.40625C4.4668 1.14778 4.67708 0.9375 4.93555 0.9375H6.81055C7.06902 0.9375 7.2793 1.14778 7.2793 1.40625V1.875H4.4668V1.40625ZM1.6543 1.875H3.5293V2.8125H8.2168V1.875H10.0918V4.57375L8.2168 6.44875V8.4375H10.0918V9.375H7.2793V14.125H1.6543V1.875Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5918 3.75H7.2793V4.6875H2.5918V3.75Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5918 5.625H7.2793V6.5625H2.5918V5.625Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5918 7.5H7.2793V8.4375H2.5918V7.5Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5415 9.5123L3.99797 11.0558L3.39191 10.4498L2.729 11.1127L3.99797 12.3816L6.20441 10.1752L5.5415 9.5123Z",
    fill: "#3F4752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_4389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDare);
export default __webpack_public_path__ + "static/media/feature_dare.73ea17a5d31e2dc72be8efe38388ab74.svg";
export { ForwardRef as ReactComponent };